<div class="cwp">
  <div class="cwp__header">
    <span>Cambiar lugar de trabajo</span>
    <button type="button" class="cwp__close" (click)="onCancel()" aria-label="Cerrar">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <div class="cwp__body">
    <div class="cwp__summary">
      <span class="cwp__summary-pair">
        <span class="cwp__summary-label">Empleado</span>
        <span class="cwp__summary-value">{{ data.employeeName }}</span>
      </span>
      <span class="cwp__summary-pair">
        <span class="cwp__summary-label">Contrato No.</span>
        <span class="cwp__summary-value">{{ data.contractNumber }}</span>
      </span>
    </div>

    <div class="cwp__error" *ngIf="errorMessage" style="margin-bottom: 16px;">
      {{ errorMessage }}
    </div>

    <div class="cwp__history">
      <div class="cwp__history-header" style="display: flex; justify-content: space-between; align-items: center; padding-bottom: 12px;">
        <span class="cwp__history-title">Histórico de lugares de trabajo</span>
        <button mat-stroked-button type="button" class="cwp__btn-add" (click)="onAddNew()" *ngIf="!isAddingNew" [disabled]="saving || loadingHistory" style="color: #6a9c27; border-color: #6a9c27;">
          <mat-icon style="font-size: 20px; width: 20px; height: 20px; line-height: 20px; margin-right: 4px;">add</mat-icon> AGREGAR LUGAR DE TRABAJO
        </button>
      </div>

      <div class="cwp__history-loading" *ngIf="loadingHistory" style="padding: 20px; text-align: center;">
        <mat-spinner diameter="30" style="margin: 0 auto;"></mat-spinner>
        <p style="margin-top: 10px; color: #666;">Cargando historial...</p>
      </div>

      <div class="cwp__history-table-wrapper" *ngIf="!loadingHistory">
        <table class="cwp__history-table">
          <thead>
            <tr>
              <th>LUGAR DE TRABAJO</th>
              <th>DESDE</th>
              <th>HASTA</th>
              <th>ESTADO</th>
              <th>REGISTRADO POR</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr *ngIf="isAddingNew" class="cwp__history-row--adding" [formGroup]="form">
              <td>
                <div class="cwp__mini-select" style="width: 140px;">
                  <app-select-search
                    style="width: 100%; display: block;"
                    [appearance]="'outline'"
                    [_dataSource]="data.projects"
                    [textInput]="''"
                    [placeholder]="'Seleccione Lugar...'"
                    [dataShow]="'Name'"
                    [dataValue]="'Id'"
                    [siteCtrl]="form.get('newProjectId')"
                    [inputType]="'text'">
                  </app-select-search>
                </div>
              </td>
              <td>
                <div class="cwp__mini-datepicker" style="width: 140px;">
                  <input class="cwp__mini-input" [matDatepicker]="pickerNewStart" formControlName="startDate"
                    placeholder="mm/dd/yyyy" [min]="minStartDate" [max]="maxStartDate" readonly>
                  <mat-datepicker-toggle class="cwp__mini-toggle" matSuffix [for]="pickerNewStart"></mat-datepicker-toggle>
                  <mat-datepicker #pickerNewStart></mat-datepicker>
                </div>
              </td>
              <td>
                <div class="cwp__mini-datepicker" style="width: 140px;">
                  <input class="cwp__mini-input" [matDatepicker]="pickerNewEnd" formControlName="endDate"
                    placeholder="mm/dd/yyyy" [min]="form.get('startDate').value || minStartDate" readonly>
                  <mat-datepicker-toggle class="cwp__mini-toggle" matSuffix [for]="pickerNewEnd"></mat-datepicker-toggle>
                  <mat-datepicker #pickerNewEnd></mat-datepicker>
                </div>
                <div style="font-size: 10px; color: #d32f2f; margin-top: 4px; line-height: 1.2; width: 140px;">Opcional. Si se deja vacía, queda vigente.</div>
              </td>
              <td>
                <span class="cwp__badge" style="background: #f5f5f5; color: #888;">Nuevo</span>
              </td>
              <td>—</td>
              <td style="text-align: center;">
                <div style="display: flex; gap: 0px; justify-content: center; align-items: center;">
                  <button mat-icon-button type="button" (click)="saveNewWorkplace()" aria-label="Guardar" matTooltip="Guardar" [disabled]="saving">
                    <mat-icon style="color: #8CC63F; font-size: 24px;">check_circle</mat-icon>
                  </button>
                  <button mat-icon-button type="button" (click)="cancelAddNew()" aria-label="Cancelar" matTooltip="Cancelar" [disabled]="saving">
                    <mat-icon style="color: #999; font-size: 24px;">cancel</mat-icon>
                  </button>
                </div>
              </td>
            </tr>
            <tr *ngFor="let row of history" [class.cwp__history-row--editing]="row.isEditing">
              <td>{{ row.projectName || 'Sin asignar' }}</td>
              <td>
                <ng-container *ngIf="!row.isEditing; else editStart">
                  {{ row.startDate | date: 'dd/MM/yyyy' }}
                </ng-container>
                <ng-template #editStart>
                  <div class="cwp__mini-datepicker">
                    <input class="cwp__mini-input" [matDatepicker]="pickerEditStart" [(ngModel)]="row.editStartDate" [ngModelOptions]="{standalone: true}">
                    <mat-datepicker-toggle class="cwp__mini-toggle" matSuffix [for]="pickerEditStart"></mat-datepicker-toggle>
                    <mat-datepicker #pickerEditStart></mat-datepicker>
                  </div>
                </ng-template>
              </td>
              <td>
                <ng-container *ngIf="!row.isEditing; else editEnd">
                  {{ row.endDate ? (row.endDate | date: 'dd/MM/yyyy') : '—' }}
                </ng-container>
                <ng-template #editEnd>
                  <div class="cwp__mini-datepicker">
                    <input class="cwp__mini-input" [matDatepicker]="pickerEditEnd" [(ngModel)]="row.editEndDate" [ngModelOptions]="{standalone: true}">
                    <mat-datepicker-toggle class="cwp__mini-toggle" matSuffix [for]="pickerEditEnd"></mat-datepicker-toggle>
                    <mat-datepicker #pickerEditEnd></mat-datepicker>
                  </div>
                </ng-template>
              </td>
              <td>
                <span class="cwp__badge" [class.cwp__badge--current]="row.isCurrent">
                  {{ row.isCurrent ? 'Actual' : 'Anterior' }}
                </span>
              </td>
              <td>
                <ng-container *ngIf="row.isSynthetic; else userAudit">
                  —
                </ng-container>
                <ng-template #userAudit>
                  <div style="font-size: 12px;">
                    <div *ngIf="row.createdDate">{{ row.createdDate | date: 'dd/MM/yyyy HH:mm' }}</div>
                    <div style="color: #666; word-break: break-word; max-width: 180px;">{{ row.createdByUserName || '—' }}</div>
                  </div>
                </ng-template>
              </td>
              <td style="text-align: center;">
                <ng-container *ngIf="!row.isSynthetic">
                  <ng-container *ngIf="!row.isEditing; else actionsEdit">
                    <button mat-icon-button type="button" (click)="editRow(row)" aria-label="Editar" matTooltip="Editar">
                      <mat-icon style="color: #8CC63F; font-size: 20px;">edit</mat-icon>
                    </button>
                  </ng-container>
                  <ng-template #actionsEdit>
                    <div style="display: flex; gap: 0px; justify-content: center; align-items: center;">
                      <button mat-icon-button type="button" (click)="saveEdit(row)" aria-label="Guardar" matTooltip="Guardar" [disabled]="saving">
                        <mat-icon style="color: #8CC63F; font-size: 24px;">check_circle</mat-icon>
                      </button>
                      <button mat-icon-button type="button" (click)="cancelEdit(row)" aria-label="Cancelar" matTooltip="Cancelar" [disabled]="saving">
                        <mat-icon style="color: #999; font-size: 24px;">cancel</mat-icon>
                      </button>
                    </div>
                  </ng-template>
                </ng-container>
              </td>
            </tr>
            <tr *ngIf="history.length === 0">
              <td colspan="6" class="cwp__history-empty">No hay registros de cambios anteriores.</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>

  <div style="display: flex; justify-content: space-between; align-items: flex-end; padding: 16px 24px; border-top: 1px solid #eee;">
    <span style="color: #888; font-size: 12px; margin-bottom: 8px;">Deje la fecha fin vacía para dejar el lugar vigente.</span>
    <div style="display: flex; flex-direction: column; align-items: flex-end; gap: 16px;">
      <span class="cwp__history-count" *ngIf="!loadingHistory" style="color: #888; font-size: 13px;">{{ history.length }} registros</span>
      <button mat-stroked-button type="button" class="cwp__btn-cancel" style="font-weight: bold; border: none; color: #555;" [disabled]="saving" (click)="onCancel()">
        CERRAR
      </button>
    </div>
  </div>
</div>
